import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { usersUpdate } from '../../actions';
import {
  GenericInput,
  Button,
  OverlayPage,
  OverlayPageContents,
  OverlayPageSection,
  OverlayPageBottomButtons,
  SuccessPopup,
  DropdownInput,
} from '../../components';
import { userActions } from '../../webapi';
import { checkLoggedIn, validateAccess } from '../../session';
import { CONST_STRINGS } from '../../config';

class AddKiosk extends Component {
  constructor(props) {
    super(props);

    this.userTypes = [
      {
        Key: 'KIOSK',
        Title: 'Standard Kiosk',
      },
      // {
      //   Key: 'FORMKIOSK',
      //   Title: CONST_STRINGS.KIOSK_FORM_LOCKOUT,
      // },
      {
        Key: 'SIGNINKIOSK',
        Title: CONST_STRINGS.KIOSK_FORM_SIGNIN,
      },
    ];

    this.state = {
      passwordInput: '',
      userEmail: '',

      uploadingImage: false,

      submitting: false,
      success: false,

      PageError: null,

      showWarnings: false,

      tempUser: {},

      selectedUserType: this.userTypes[0],
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    /*   this.onNewProps(nextProps); */
  }

  UNSAFE_componentWillMount() {
    checkLoggedIn(this, this.props.auth);
  }

  componentDidMount() {
    if (!validateAccess(this.props.auth.site, 'userManagement', this.props.auth, true)) {
      this.props.history.push('/mastermenu');
    }
  }

  selectType(key, e) {
    this.setState({
      selectedUserType: _.find(this.userTypes, (t) => {
        return t.Key === key;
      }),
    });
  }

  isEmail(email) {
    const atpos = email.indexOf('@');
    const dotpos = email.lastIndexOf('.');
    if (atpos < 1 || dotpos < atpos + 2 || dotpos + 2 >= email.length) {
      return false;
    }
    return true;
  }

  validateEmail() {
    return !_.isEmpty(this.state.userEmail) && this.isEmail(this.state.userEmail);
  }

  validatePassword() {
    return this.state.passwordInput.length > 5;
  }

  validateForm() {
    if (!this.validateEmail()) {
      return false;
    }
    if (!this.validatePassword()) {
      return false;
    }
    return true;
  }

  handleSubmit() {
    if (!this.validateForm()) {
      this.setState({ showWarnings: true });
      return;
    }
    if (this.state.submitting) {
      return;
    }

    this.setState({ showWarnings: false, submitting: true, PageError: null });

    var user = {
      displayName: this.state.userEmail,
      password: this.state.passwordInput,
    };

    if (!_.isEmpty(this.state.userEmail) && this.isEmail(this.state.userEmail)) {
      user.email = this.state.userEmail.toLowerCase();
      user.emailVerified = false;
    }

    var userExtra = {
      type: this.state.selectedUserType.Key,
      location: this.props.auth.site,
    };
    userActions
      .createNewUser(user, userExtra)
      .then((res) => {
        if (res.data.userCreationFail) {
          this.setState({
            PageError: res.data.message,
            submitting: false,
          });
        } else {
          this.setState({
            success: true,
            submitting: false,
            tempUser: res.data.user,
          });
          this.props.usersUpdate(this.props.auth.site);
        }
      })
      .catch((error) => {
        this.setState({ submitting: false, PageError: 'Something went wrong. Please try again.' });
        console.log(error);
      });
  }

  handleChange(event) {
    var stateChange = {};
    stateChange[event.target.getAttribute('id')] = event.target.value;
    this.setState(stateChange);
  }

  renderForm() {
    return (
      <div>
        <div className="padding-60 paddingVertical-40 bottomDivideBorder">
          <p className="text-sectionTitle">NEW KIOSK LOGIN</p>
          <input autoComplete="false" name="hidden" type="text" style={{ display: 'none' }} />
          <GenericInput
            id="userEmail"
            type="text"
            label="Email"
            placeholder="Email"
            value={this.state.userEmail}
            onChange={(e) => this.handleChange(e)}
            showError={() => {
              return this.state.showWarnings && !this.validateEmail();
            }}
            errorMessage="Not a valid email"
            autoComplete={false}
          />
          <GenericInput
            id="passwordInput"
            type="text"
            label="Password"
            placeholder="Password"
            value={this.state.passwordInput}
            onChange={(e) => this.handleChange(e)}
            showError={() => {
              return this.state.showWarnings && !this.validatePassword();
            }}
            errorMessage="Password must be at least 6 characters"
            autoComplete={false}
          />
          <DropdownInput
            id="typeSelect"
            label="Type of Kiosk"
            placeholder="Standard Kiosk"
            value={this.state.selectedUserType.Title}
            options={this.userTypes}
            onSelect={this.selectType.bind(this)}
          />
        </div>
      </div>
    );
  }

  renderSubmit() {
    if (this.state.submitting) {
      return <Button buttonType="secondary">Saving...</Button>;
    }
    return (
      <div>
        <Button
          inline
          buttonType="tertiary"
          onClick={() => {
            window.history.back();
          }}
          isActive
          style={{ marginRight: 16 }}
        >
          Cancel
        </Button>
        <Button inline buttonType="primary" onClick={this.handleSubmit.bind(this)} isActive={this.validateForm()}>
          Save
        </Button>
      </div>
    );
  }

  renderSuccess() {
    if (!this.state.success) {
      return null;
    }
    return (
      <SuccessPopup
        text="Kiosk login has been created"
        buttons={[
          {
            type: 'outlined',
            onClick: () => {
              window.history.back();
            },
            text: 'Go to home',
          },
        ]}
      />
    );
  }

  onBackPress() {
    if (this.state.submitting) {
      return;
    }
    this.props.onBack(null);
  }

  renderError() {
    if (this.state.PageError) {
      return (
        <div className="padding-60 paddingVertical-40 bottomDivideBorder">
          <div style={{ fontWeight: 'bold', color: 'red', fontSize: 20 }}>{this.state.PageError}</div>
        </div>
      );
    }
    return null;
  }

  render() {
    return (
      <OverlayPage>
        {this.renderSuccess()}
        <OverlayPageContents noBottomButtons={this.state.success}>
          <OverlayPageSection className="pageSectionWrapper--newPopup">
            <div style={{ marginBottom: 60 }}>
              {!this.state.success && this.renderForm()}
              {this.renderError()}
            </div>
          </OverlayPageSection>
        </OverlayPageContents>
        <OverlayPageBottomButtons>{this.renderSubmit()}</OverlayPageBottomButtons>
      </OverlayPage>
    );
  }
}

const mapStateToProps = (state) => {
  const { auth } = state;
  return { auth };
};

export default connect(mapStateToProps, { usersUpdate })(withRouter(AddKiosk));
